import { SystemFuncArgs } from '$legacyecstatic';
import { Components } from 'editor/components';
import Cursor, { CursorTypes } from 'editor/components/Cursor';
import DomElement from 'editor/components/DomElement';

export const manageCursorComponents = [Cursor, DomElement];

// TODO: This system should replace the configureCursor system once there is time to refactor the editor to use it.
export function manageCursor(args: SystemFuncArgs<Components>): void {
  const { components } = args;

  const cursorComp = components.get(Cursor);
  const domElComp = components.get(DomElement);

  // guessing the "Tracked" might be best to use on Cursor.
  if (cursorComp.cursor !== cursorComp.prevCursor) {
    domElComp.element.style.cursor = cursorComp.cursor;
    cursorComp.prevCursor = cursorComp.cursor;
  }

  if (cursorComp.disabled) {
    domElComp.element.style.removeProperty('cursor');
    cursorComp.cursor = CursorTypes.Default;
  }
}
